import { DesktopDatePicker } from '@mui/lab';
import { DateTime } from 'luxon';
import { TextField } from '@mui/material';
import { useCalendar } from './CalendarProvider';


const CalendarDate = () =>
{
	const { selected_day, onDaySelected } = useCalendar();
	
	
	return <div
		className='calendar3_date'
	>
		<DesktopDatePicker
			label='Date'
			inputFormat='yyyy-MM-dd'
			value={selected_day}
			onChange={(datetime: DateTime) => {
				if(datetime.isValid)
					onDaySelected(datetime)
			}}
			renderInput={(params) => <TextField {...params} />}
		/>
	</div>
}


export default CalendarDate;